import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLoading, getData } from "@icarius-pages/issueTypesSettings/selectors";
import { getAppColor } from "@icarius-app/selectors";
import { Grid } from "@material-ui/core";
import DataItem from "./data/dataItem";
import { RESET_STATE } from "@icarius-pages/issueTypesSettings/actionTypes";
import ABMLayout from "@icarius-common/abmComponents/abmLayout";
import { getPermissionTypesAction } from "@icarius-pages/issueTypesSettings/actions";
import { getLocalizedString } from "@icarius-localization/strings";

const Permission = ({ handleGoBack }) => {
    const [createIsOpen, setCreateIsOpen] = useState(false);

    const dispatch = useDispatch();

    const color = useSelector(getAppColor);
    const data = useSelector(getData);
    const isLoading = useSelector(getLoading);

    useEffect(() => {
        dispatch(getPermissionTypesAction());
        return () => {
            dispatch({ type: RESET_STATE });
        };
    }, [dispatch]);

    const getDataIsEmpty = () => {
        return !data || data.length === 0;
    };

    return (
        <ABMLayout
            title={getLocalizedString("permissionTypes")}
            isLoading={isLoading}
            showCreateButton={!createIsOpen}
            createButtonTitle={getLocalizedString("newPermissionType")}
            createButtonOnClick={() => setCreateIsOpen(true)}
            showGoBack
            handleGoBack={handleGoBack}
            showNoData={getDataIsEmpty()}
            noDataTitle={getLocalizedString("noPermissionTypesFound")}
            noDataCreateTitle={getLocalizedString("newPermissionType")}
            noDataOnClick={() => setCreateIsOpen(true)}
        >
            {createIsOpen && (
                <Grid container item xs={12} style={{ margin: "10px 0px" }}>
                    <DataItem color={color} data={null} closeNew={() => setCreateIsOpen(false)} />
                </Grid>
            )}
            {data &&
                data.map((item) => {
                    return (
                        <Grid container item xs={12} style={{ margin: "10px 0px" }} key={item.code}>
                            <DataItem data={item} color={color} />
                        </Grid>
                    );
                })}
        </ABMLayout>
    );
};

export default Permission;
